export default "__VITE_ASSET__f2862343__"